<template>
  <div style="margin: 10px">
    <v-card>
      <div class="headline dialog-header" >
        <v-toolbar color="primary" dark>
          <v-toolbar-title style="padding-left: 10px"
          >{{ $t(formName) }}
          </v-toolbar-title>
        </v-toolbar>
        <v-btn
            @click="onCancel"
            icon
            style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
        >
          <v-icon>cancel</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 sm12 md4>
            <div style="padding: 20px 10px">
              <p class="font-weight-bold">
                Khu nuôi:
                {{areaCode}}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <div style="padding: 20px 10px">
              <p class="font-weight-bold">
                Ngày xuất kho yêu cầu:
                {{formatDate(values.exportDate)}}
              </p>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-tabs>
      <v-tabs-slider color="#2196F3"></v-tabs-slider>
      <v-tab>
        Tổng hợp
      </v-tab>
      <v-tab
          v-for="item in lstRequest"
          :key="item.exportId"
      >
        {{item.requestNumber}}-{{item.cropCode}}
      </v-tab>

      <v-tabs-items>
        <v-tab-item>

          <not-process-summary-view :values-prop="values" :show-dialog-header="false"/>
        </v-tab-item>
        <v-tab-item
            v-for="item in lstRequest"
            :key="item.exportId"
        >
          <not-process-view :export-id="item.exportId" :show-dialog-header="false" :from-summary="true"/>
        </v-tab-item>
<!--        <v-tab-item>-->
<!--          -->
<!--        </v-tab-item>-->
<!--        <v-tab-item>-->
<!--          <export-request-view export-id="9" :show-dialog-header="false"/>-->
<!--        </v-tab-item>-->
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import {message} from "../../../shared/message";
import {areaContants, roleConstants} from "@/constants";
import NotProcessView from "@/views/admin/export_request/NotProcessView";
import NotProcessSummaryView from "@/views/admin/export_request/NotProcessSummaryView";

export default {
  name: "NotProcessApprove",
  components: {NotProcessSummaryView, NotProcessView, IDatepicker, },
  props: {
    valuesProp: {
      type: Object,
      default: ()=> {}
    },
  },
  data: () => {
    return {
      formName: "Phê duyệt đề nghị xuất kho không theo quy trình",
      loading: false,
      roleGroup: 2,
      values: {
          areaId: "-1",
          exportDate: ""
      },
      lstRequest: [],
      areaCode: '',
    };
  },

  created() {
    // 4: kỹ sư trưởng
    // const role = parseInt(this.$store.state.auth.user.role);
    // if (role == 4) {
    //   this.roleGroup = 2;
    // }
    if(this.valuesProp != undefined
        && this.valuesProp.areaId!= "" && this.valuesProp.areaId!= undefined
        && this.valuesProp.exportDate!= "" && this.valuesProp.exportDate!= undefined
        && this.valuesProp.status!= ""&& this.valuesProp.status!= undefined){
      this.values.areaId = this.valuesProp.areaId;
      this.values.exportDate = this.valuesProp.requestDate;
      this.values.status = this.valuesProp.status;
      this.values.materialTypeAllyId = this.valuesProp.materialTypeAllyId;
    } else if(this.$route.params.areaId != undefined && this.$route.params.areaId !=""
        && this.$route.params.requestDate != undefined && this.$route.params.requestDate !=""
        && this.$route.params.status != undefined && this.$route.params.status !=""){
      this.values.areaId = this.$route.params.areaId;
      this.values.exportDate = this.$route.params.requestDate;
      this.values.status = this.$route.params.status;
      this.values.materialTypeAllyId = this.$route.params.materialTypeAllyId;
    }

  },
  watch: {
    valuesProp: {
      handler(value) {
        this.values.areaId = value.areaId;
        this.values.exportDate = value.requestDate;
        this.values.status = value.status;
        this.values.materialTypeAllyId = value.materialTypeAllyId;
      },
      deep: true
    },
    values: {
      handler(value) {
        let tempValue = Object.assign({}, value, {"exportType": 2})
        this.getListRequest(tempValue);
        this.getPondArea(value.areaId)

        // if(this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR){
        //   let tempValue = Object.assign({}, value, {"status": 2, "exportType": 2})
        //   this.getListRequest(tempValue);
        //   this.getPondArea(value.areaId)
        // } else if(this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER){
        //   let tempValue = Object.assign({}, value, {"status": 1, "exportType": 2})
        //   this.getListRequest(tempValue);
        //   this.getPondArea(value.areaId)
        // }
      },
      deep: true
    },
  },

  methods: {
    onCancel() {
      this.$router.push({path: '/exportRequest'});
    },
    getPondArea(areaId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=PONDAREA&pageSize=-1&page=-1",
          {categoryId: areaId}
      )
          .then((data) => {
            if (data.items) {
              this.areaCode = data.items[0].categoryName;
              // this.getWarehouse(data.items[0].categoryId);
            }
          });
    },
    getListRequest(values) {
      if (values.areaId != -1) {
        const params = values;
        params.exportType = 2;
        axios
            .post(
                process.env.VUE_APP_API_URL + "/exportRequest/searchViewV2?pageSize=-1&page=-1",
                params
            )
            .then((data) => {
              if (data.items) {
                this.lstRequest=data.items;
              }
            });
      }
    },
    formatDate(date) {
      return moment(String(date)).format('DD/MM/YYYY');
    },
  },

  destroyed() {
  },
};
</script>
